import styled from 'styled-components';

// TODO: TFR-45:Avatar make unique name or do not export
const Avatar = styled.img`
  height: 3rem;
  width: 3rem;
  border-radius: 1.5rem;
  object-fit: cover;
`;

export default Avatar;
